/**
 * Areas of Interest capture (Phase 2 gaze analytics).
 *
 * Reads every element tagged with `data-aoi="<label>"` and records its
 * on-screen rectangle as viewport percentages (0-100) — the same coordinate
 * space gaze/mouse are stored in. Captured per question at answer time, so each
 * participant's fixations can later be mapped to what they actually looked at
 * (dwell, time-to-first-fixation, attention order per region).
 *
 * @returns {Array<{label:string,x:number,y:number,w:number,h:number}>}
 */
export function captureAois() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return [];

  const vw = window.innerWidth || 1;
  const vh = window.innerHeight || 1;
  const round = (n) => Math.round(n * 10) / 10;

  const nodes = document.querySelectorAll('[data-aoi]');
  const aois = [];

  nodes.forEach((el) => {
    const label = el.getAttribute('data-aoi');
    if (!label) return;
    const r = el.getBoundingClientRect();
    // Skip elements that aren't laid out (hidden / zero-size).
    if (r.width <= 0 || r.height <= 0) return;

    aois.push({
      label,
      x: round((r.left / vw) * 100),
      y: round((r.top / vh) * 100),
      w: round((r.width / vw) * 100),
      h: round((r.height / vh) * 100),
    });
  });

  return aois;
}
